import type { AmplitudeExperimentsContextType } from '@/components/AmplitudeExperimentsProvider/Context';
import type { GlobalState } from '@/redux/store';
import type { FeatureFlags } from '@/types/FeatureFlags';

export const SERVER_DATA_ELEMENT_ID = '__SERVER_DATA__';

export type ServerData = {
    amplitudeExperiments: AmplitudeExperimentsContextType;
    data: GlobalState;
    featureFlags: FeatureFlags;
};
